import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13.75 11.75c-.375 0-.625.25-.625.625V18h-10V3h8.125c.375 0 .625-.25.625-.625s-.25-.625-.625-.625H3.125c-.687 0-1.25.563-1.25 1.25v15c0 .688.563 1.25 1.25 1.25h10c.688 0 1.25-.562 1.25-1.25v-5.625c0-.375-.25-.625-.625-.625" }, null, -1),
    _createElementVNode("path", { d: "m14.938 2.313-9.125 9.125a.57.57 0 0 0-.188.437v1.75c0 .375.25.625.625.625H8a.57.57 0 0 0 .438-.187l9.125-9.125c.687-.75.687-1.938-.063-2.625s-1.875-.688-2.562 0m1.75 1.75L7.75 13h-.875v-.875l8.938-8.937c.25-.25.624-.25.874 0s.25.624 0 .874" }, null, -1)
  ]))]))
}
export default { render: render }